var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSocialTg = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 40 40"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M15.5 24.462 30.613 9.837s.8-1.037-.825 0l-19.163 13-6.5-2.6S2.613 19.7 2.5 18.775s1.625-1.625 1.625-1.625L32.638 5.337c-.013 0 2.362-1.125 2.362.725L29.788 31.8s-.513 2.525-2.475 1.6c0 0-5.288-3.788-7.738-5.688l-3.9 5.688c-.787 1.012-1.787.675-1.787 0z",
  clipRule: "evenodd"
})));
export default SvgSocialTg;